export const maxZoom = 3000
export const minZoom = 10
export const defaultZoom = 100

export const getZoomAmount = (zoomStep?:number | null) => {
    switch(zoomStep) {
        case 1:
            return 180
        case 2:
            return 160
        case 3:
            return 140
        case 4:
            return 110
        case 5:
            return 100
        case 6:
            return 95
        case 7:
            return 90
        case 8:
            return 85
        case 9:
            return 80
        case 10:
            return 75
        case 11:
            return 65
        case 12:
            return 55
        case 13:
            return 45
        case 14:
            return 35
        default:
            return 110
    }
}

export const getSize = (zoomAmount: number) => {

        
    const scaleAmount = (zoomAmount/180)

    const defaultWidth = 158
    const defaultHeight = 158

    const iconSize = 32

    return { 
        width: Math.ceil(defaultWidth * scaleAmount), 
        height: Math.ceil(defaultHeight * scaleAmount), 
        margin: Math.ceil(8 * scaleAmount), 
        paddingTop: Math.ceil(8 * scaleAmount), 
        paddingRight: Math.ceil(4 * scaleAmount), 
        paddingLeft: Math.ceil(4 * scaleAmount),
        averagePadding: Math.ceil(8 * scaleAmount),
        fontSize: `${.7*scaleAmount}em`,
        titleFontSize: `${28*scaleAmount}px`,

        iconSize: iconSize * scaleAmount,
        defaultWidth,
        defaultHeight,

    }
}


// WEBPACK FOOTER //
// ./src/components/PhasePlan/Zoom.util.ts